import React from "react";

const UserPage = () => {
  return <div>user page</div>;
};

export default UserPage;
